import axios from "axios"
import moment from "moment"
import _ from "underscore"
import * as actions from "../actions"

const hsgapi_endpoint = process.env.REACT_APP_API_ENDPOINT

export const defaultOptions = (token, timestamp, method = "GET") => ({
  credentials: "same-origin",
  cache: "no-cache",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "x-webtoken": process.env.REACT_APP_HSG_TOKEN,
    "x-stamp": `${timestamp}`,
  },
  method: method,
})

export const fetchAppDetails = () => {
  return (dispatch) => {
    dispatch(actions.requestAppDetails())

    axios
      .get(
        `${hsgapi_endpoint}/init`,
        _.omit(defaultOptions(null, moment().unix()), "Authorization")
      )
      .then(checkStatus)
      .then((response) => {
        dispatch(
          actions.receiveAppDetails(
            response.data.locations,
            response.data.products,
            response.data.userCountryDetected
          )
        )
      })
      .catch(
        catchApiErrorWith((error) => {
          dispatch(actions.receiveAppDetailsError(error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchUserGameDetails = (token) => {
  return (dispatch) => {
    dispatch(actions.requestUserGameDetails())

    axios
      .get(`${hsgapi_endpoint}/games`, defaultOptions(token, moment().unix()))
      .then(checkStatus)
      .then((response) => {
        dispatch(actions.receiveUserGameDetails(response.data.games))
      })
      .catch(
        catchApiErrorWith((error) => {
          dispatch(actions.receiveUserGameDetailsError(error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchStartGame = (gameUuid, token) => {
  return (dispatch) => {
    dispatch(actions.requestStartGame(gameUuid))
    axios
      .post(
        `${hsgapi_endpoint}/games/${gameUuid}/start`,
        {},
        defaultOptions(token, moment().unix())
      )
      .then(checkStatus)
      .then((response) => {
        console.log("resp", response)
        if (response.data.status === "success") {
          dispatch(actions.receiveStartGame(gameUuid, response.data.game))
        } else {
          throw new Error(response.data)
        }
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error)
          dispatch(actions.receiveStartGameError(gameUuid, error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchUpdateGame = (gameUuid, data = {}, token) => {
  return (dispatch) => {
    dispatch(actions.requestUpdateGame(gameUuid))
    axios
      .patch(
        `${hsgapi_endpoint}/games/${gameUuid}`,
        data,
        defaultOptions(token, moment().unix())
      )
      .then(checkStatus)
      .then((response) => {
        console.log("resp", response)
        if (response.data.status === "success") {
          dispatch(actions.receiveUpdateGame(gameUuid, response.data.updatedGame, response.data.updatedTeam))
        } else {
          throw new Error(response.data)
        }
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error)
          dispatch(actions.receiveUpdateGameError(gameUuid, error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchTeamMembers = (teamUuid, token) => {
  return (dispatch) => {
    dispatch(actions.requestTeamMembers(teamUuid))

    axios
      .get(
        `${hsgapi_endpoint}/teams/${teamUuid}/members`,
        _.omit(defaultOptions(token, moment().unix()), "Authorization")
      )
      .then(checkStatus)
      .then((response) => {
        dispatch(actions.receiveTeamMembers(teamUuid, response.data.team))
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error)
          dispatch(actions.receiveTeamMembersError(teamUuid, error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchInviteTeamMembers = (teamUuid, token, teamMembers) => {
  return (dispatch) => {
    dispatch(actions.requestInviteTeamMembers(teamUuid, teamMembers))

    axios
      .post(
        `${hsgapi_endpoint}/teams/${teamUuid}/invite`,
        { members: teamMembers },
        _.omit(defaultOptions(token, moment().unix()), "Authorization")
      )
      .then(checkStatus)
      .then((response) => {
        dispatch(actions.receiveInviteTeamMembers(teamUuid, response.data.team, response.data.errors))
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error)
          dispatch(actions.receiveInviteTeamMembersError(error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const acceptTeamInvite = (token, inviteUuid) => {
  return (dispatch) => {
    dispatch(actions.requestAcceptTeamInvite(inviteUuid))

    axios
      .post(`${hsgapi_endpoint}/invite/${inviteUuid}`, {}, defaultOptions(token, moment().unix()))
      .then(checkStatus)
      .then((response) => {
        console.log(response.data)
        dispatch(actions.receiveAcceptTeamInvite(response.data.message, response.data.status, inviteUuid))
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error.response)
          dispatch(actions.receiveAcceptTeamInviteError(error, inviteUuid))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}


export const deleteTeamInvite = (teamUuid, token, inviteUuid) => {
  return (dispatch) => {
    dispatch(actions.requestDeleteTeamInvite(teamUuid, inviteUuid))

    axios
      .delete(
        `${hsgapi_endpoint}/teams/${teamUuid}/invite/${inviteUuid}`,
        _.omit(defaultOptions(token, moment().unix()), "Authorization"),
      )
      .then(checkStatus)
      .then((response) => {
        console.log("resp", response)
        dispatch(actions.receiveUpdatedTeam(response.data.team))
      })
      .catch(
        catchApiErrorWith((error) => {
          dispatch(actions.receiveDeleteTeamInviteError(error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const deleteTeamMember = (teamUuid, token, memberUuid) => {
  return (dispatch) => {
    dispatch(actions.requestDeleteTeamMember(teamUuid, memberUuid))

    axios
      .delete(
        `${hsgapi_endpoint}/teams/${teamUuid}/members/${memberUuid}`,
        _.omit(defaultOptions(token, moment().unix()), "Authorization"),
      )
      .then(checkStatus)
      .then((response) => {
        console.log("resp", response)
        dispatch(actions.receiveUpdatedTeam(response.data.team))
      })
      .catch(
        catchApiErrorWith((error) => {
          dispatch(actions.requestDeleteTeamMember(error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchWeAreLost = (gameUuid, token, addressOnly = false) => {
  return (dispatch) => {
    dispatch(actions.requestLostGameDetails(gameUuid))

    const result = axios
      .get(
        `${hsgapi_endpoint}/games/${gameUuid}/lost`,
        _.omit(defaultOptions(token, moment().unix()), "Authorization")
      )
      .then(checkStatus)
      .then((response) => {
        if (addressOnly) {
          return response.data.details
        }
        dispatch(actions.receiveLostGameDetails(gameUuid, response.data))
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error)
          dispatch(actions.receiveLostGameDetailsError(gameUuid, error))
        })
      )
    return result
  }
}

export const fetchHandleSkipAheadInitial = (gameUuid, cabinetId, phoneNumber, brokenCabinetId, token) => {
  return (dispatch) => {
    dispatch(actions.requestSkipAheadHelp(gameUuid, cabinetId))

    axios
      .post(
        `${hsgapi_endpoint}/games/${gameUuid}/skipahead/${cabinetId}`,
        { phoneNumber: phoneNumber,
          brokenCabinetId: brokenCabinetId
        },
        _.omit(defaultOptions(token, moment().unix()), "Authorization")
      )
      .then(checkStatus)
      .then((response) => {
        console.log(response)
        dispatch(actions.receiveSkipAheadHelp(gameUuid, cabinetId, response.data.message, response.data.urls, response.data.verification))
      })
      .catch(
        catchApiErrorWith((error) => {
          dispatch(actions.receiveSkipAheadHelpError(error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}

export const fetchHandleSkipAheadVerify = (gameUuid, cabinetId, phoneNumber, code, token) => {
  return (dispatch) => {
    dispatch(actions.requestSkipAheadHelp(gameUuid, cabinetId))

    axios
      .post(
        `${hsgapi_endpoint}/games/${gameUuid}/skipahead/${cabinetId}/verify`,
        { phoneNumber: phoneNumber, code: code },
        _.omit(defaultOptions(token, moment().unix()), "Authorization")
      )
      .then(checkStatus)
      .then((response) => {
        dispatch(actions.receiveSkipAheadHelp(gameUuid, cabinetId, response.data.message, response.data.urls, response.data.verification))
        dispatch(fetchUserGameDetails(token))
      })
      .catch(
        catchApiErrorWith((error) => {
          console.log("error", error)
          dispatch(actions.receiveSkipAheadHelpError(gameUuid, cabinetId, error))
          error.message !== "Network Error" && dispatch(actions.addErrorMessage(`${error.type || ""} ${error.message}`))
        })
      )
  }
}


// Create a handler for any errors caught on API calls.
export const catchApiErrorWith = (handler, validationHandler) => {
  return (error) => {
    if (error instanceof ValidationError && validationHandler) {
      console.log(error)
      return validationHandler(error)
    }
    if (error instanceof ApiError) {
      console.log("API ERROR", error)
      return handler(error)
    }
    const errorsObj = _.get(error, ["response", "data", "errors"])

    if (errorsObj) {
      if (errorsObj.type === "Internal Server Error") {
        return handler({ type: errorsObj.type, message: "Something went wrong on our server."})
      } else {
        return handler(errorsObj)
      }
    }
    
    return handler(error)
  }
}
function ValidationError(response) {
  this.name = "ValidationError"
  this.response = response
}
ValidationError.prototype = new Error()

// An error type to signify errors relating to the API
function ApiError(message, response) {
  this.name = "ApiError"
  this.message = message
  this.response = response
  this.stack = new Error().stack
}
ApiError.prototype = new Error()

// Throw an error when the response status is not 2xx.
export const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else if (response.status === 400) {
    throw new ValidationError(response)
  } else {
    throw new ApiError(response.statusText, response)
  }
}
